// @flow
import React, { useEffect, useState, useRef } from 'react';
import { connect } from 'react-redux';
import { CSVLink } from 'react-csv';
import debounce from 'lodash.debounce';
import {
  Card,
  Table,
  Row,
  Col,
  Icon,
  Tooltip,
  Badge,
} from 'antd';
import queryString from 'query-string';
import { useLocation } from 'react-router-dom';

import Loading from 'components/Loading';
import Filters from 'components/Filters';
import getFilterOperators from 'utils/getFilterOperators';

import {
  PAGES,
  FILTERS_TYPES,
  FILTER_STATUSES,
} from 'appconstants';
import {
  SpButton,
  FilterWrapper,
  SpText,
} from 'components/DesignKit';

import { acquirerActions, filterParamsActions } from 'store/actions';
import { FILTERS_SPECS } from 'store/actionTypes';
import moment from 'moment-timezone';

import FilterIcon from 'components/NavIcons/filterIcon';
import ExportIcon from 'components/NavIcons/exportIcon';
import DeleteAcquirer from './components/DeleteAcquirer';
import AddAcquirer from './components/AddAcquirer';
import UpdateAcquirer from './components/UpdateAcquirer';

const MOMENT_FORMAT = 'YYYY-MM-DDTHH:mm:ss';
const ACQUIRER_FILTERS_TYPES = FILTERS_TYPES.ACQUIRER;
const AcquirerTypes = FILTER_STATUSES.ACQUIRER;
const placeholder = 'Select type';

type Props = {
  fetchAcquirer: Function,
  acquirer: Array<Object>,
  loading: boolean,
  test: boolean,
  totalElements: number,
  history: {
    push: Function,
  },
  selectedAccount: Object,
  submitting: boolean,
  addAcquirer: Function,
  validator: boolean,
  deleteAcquirer: Function,
  updateAcquirer: Function,
  setFilterData: Function,
  preserveFilters: Object,
  isMobileView: Boolean,
};

const Acquirer = (props: Props) => {
  const {
    loading,
    fetchAcquirer,
    acquirer,
    totalElements,
    test,
    history,
    selectedAccount,
    submitting,
    addAcquirer,
    validator,
    deleteAcquirer,
    updateAcquirer,
    setFilterData,
    preserveFilters,
    isMobileView,
  } = props;

  const tableId = document.getElementsByTagName('table');
  if (tableId && tableId[0] && isMobileView) {
    tableId[0].style.width = '1600px';
  } else if (tableId && tableId[0] && !isMobileView) {
    tableId[0].style.width = '100%';
  }

  const location = useLocation();
  const myRef = useRef();
  const [open, setOpen] = useState(false);
  const [pagination, setPagination] = useState({});
  const [deleteAcquirerModal, setDeleteAcquirerModal] = useState(false);
  const [selectedAcquirer, setSelectedAcquirer] = useState({});
  const [addAcquirerModal, setAddAcquirerModal] = useState(false);
  const [editAcquirerModal, setEditAcquirerModal] = useState(false);
  const [filterTypes, setFilterTypes] = useState(ACQUIRER_FILTERS_TYPES);
  const [fiterOperators, setFilterOperators] = useState([]);
  const { pathname } = location;
  const [filterAcquirer, setFilterAcquirer] = useState((preserveFilters && preserveFilters.filterAcquirer)
    ? (preserveFilters && preserveFilters.filterAcquirer)
    : [{
      filterType: '',
      filterName: '',
      filterOperator: '',
      filterValue: '',
      filterNameDisplay: '',
      filterValueFrom: '',
      filterValueTo: '',
      checked: true,
    }]);
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [currentDate, setCurrentDate] = useState('');
  const [count, setCount] = useState(null);
  const [fillColor, setFillColor] = useState(false);
  const [filterColor, setFilterColor] = useState(false);

  const exportData = acquirer ? acquirer.map((values) => ({
    name: values && values.name,
    type: values && values.type,
    test: (values && values.test) === true ? 'Yes' : 'No',
    createdAt: moment
      .utc(values && values.createdAt)
      .tz(selectedAccount && selectedAccount.timezone)
      .format('MMM DD, YYYY, hh:mm a'),
  })) : '';

  const preserveParam = ((preserveFilters && preserveFilters.pathname) === pathname)
    ? queryString.parse(preserveFilters.search)
    : setFilterData({
      pathname,
      search: '',
      filterAcquirer: [{
        filterType: '',
        filterName: '',
        filterOperator: '',
        filterValue: '',
        filterNameDisplay: '',
        filterValueFrom: '',
        filterValueTo: '',
        checked: true,
      }],
    });

  const exportHeaders = [
    { label: 'NAME', key: 'name' },
    { label: 'TYPE', key: 'type' },
    { label: 'IS TEST', key: 'test' },
    { label: 'CREATED ON', key: 'createdAt' },
  ];

  const debouncedFetchAcquirer = debounce(fetchAcquirer, 2000, { leading: true });

  const getData = (query) => {
    const parsed = queryString.parse(query);
    const currentPage = parsed.pageNum || 1;
    const sortBy = parsed.sortBy || 'createdAt';
    const direction = parsed.direction || 'DESC';
    const sortParams = `&sortBy=${sortBy}&direction=${direction}`;
    const filterParam = parsed.filterParams || '';
    const filterParams = (preserveParam ? preserveParam.filterParams : filterParam || '');
    debouncedFetchAcquirer({ currentPage, sortParams, filterParams });
  };

  const handleClick = e => {
    if (myRef.current && myRef.current.contains(e.target)) {
      return;
    }
    if (e.target.value === undefined
      && e.toElement.className !== 'ant-calendar-date'
      && e.toElement.className !== 'ant-calendar-prev-month-btn'
      && e.toElement.className !== 'ant-calendar-next-month-btn') {
      setOpen(false);
    }
  };

  useEffect(() => {
    getData(location.search);
  }, [test, selectedAccount, location]);

  useEffect(() => {
    const parsed = queryString.parse(location.search);
    const currentPage = parsed.pageNum || 1;
    setPagination(existingElements => ({
      ...existingElements,
      total: totalElements,
      current: parseInt(currentPage, 10),
      showTotal: total => `Total ${total} items`,
    }));
  }, [acquirer]);

  useEffect(() => {
    document.addEventListener('mousedown', handleClick);
    return () => {
      document.removeEventListener('mousedown', handleClick);
    };
  }, []);

  useEffect(() => {
    if (!validator) {
      setAddAcquirerModal(false);
      setDeleteAcquirerModal(false);
      setEditAcquirerModal(false);
    }
  }, [validator]);

  const handleTableChange = (page, sorter, filters) => {
    const parsed = queryString.parse(location.search);
    const filterParams = parsed.filterParams || '';
    const tempPage = page.current;
    let tempParams = '';
    if (filters.order === 'ascend') {
      tempParams = `&sortBy=${filters.field}&direction=ASC`;
    } else if (filters.order === 'descend') {
      tempParams = `&sortBy=${filters.field}&direction=DESC`;
    } else {
      tempParams = '';
    }
    if (location.search && filterParams) {
      const filterParam = encodeURIComponent(filterParams);
      history.push({
        pathname: PAGES.ACQUIRER,
        search: `?filterParams=${filterParam}&pageNum=${tempPage}${tempParams}`,
      });
    } else {
      history.push({
        pathname: PAGES.ACQUIRER,
        search: `?pageNum=${tempPage}${tempParams}`,
      });
    }
  };

  const showDeleteAcquirerModal = (value: Object) => {
    setSelectedAcquirer(value);
    setDeleteAcquirerModal(true);
  };

  const showEditAcquirerModal = (value: Object) => {
    setSelectedAcquirer(value);
    setEditAcquirerModal(true);
  };


  const deleteSelectedAcquirer = (gid: string) => {
    const parsed = queryString.parse(location.search);
    const currentPage = parsed.pageNum || 1;
    const sortBy = parsed.sortBy || 'createdAt';
    const direction = parsed.direction || 'DESC';
    const sortParams = `&sortBy=${sortBy}&direction=${direction}`;

    deleteAcquirer({
      gid,
      currentPage,
      sortParams,
    });
  };

  const addNewAcquirer = (data: Object) => {
    const parsed = queryString.parse(location.search);
    const currentPage = parsed.pageNum || 1;
    const sortBy = parsed.sortBy || 'createdAt';
    const direction = parsed.direction || 'DESC';
    const sortParams = `&sortBy=${sortBy}&direction=${direction}`;
    const {
      name,
      type,
      isTest,
      isOnline,
    } = data;

    const params = {
      name,
      type,
      test: isTest,
      online: isOnline,
    };

    addAcquirer({
      params,
      currentPage,
      sortParams,
    });
  };

  const editAcquirer = (data: Object) => {
    const parsed = queryString.parse(location.search);
    const currentPage = parsed.pageNum || 1;
    const sortBy = parsed.sortBy || 'createdAt';
    const direction = parsed.direction || 'DESC';
    const sortParams = `&sortBy=${sortBy}&direction=${direction}`;
    const {
      name,
      type,
      isTest,
      isOnline,
      id,
    } = data;

    const params = {
      name,
      type,
      test: isTest,
      online: isOnline,
    };

    updateAcquirer({
      id,
      params,
      currentPage,
      sortParams,
    });
  };

  const onCheck = (e, index) => {
    const list = [...filterAcquirer];
    if (filterAcquirer.length !== 1) {
      if (!e) {
        list.splice(index, 1);
        const filterTypeOptions = ACQUIRER_FILTERS_TYPES.filter(({ value: id1 }) => !list.some(({ filterName: id2 }) => id2 === id1));
        setFilterTypes(filterTypeOptions);
      } else {
        list[index].checked = e;
      }
    }
    setFilterAcquirer(list);
  };

  const handleChange = (e, index) => {
    const list = [...filterAcquirer];
    if (e[1] === 'createdAt') {
      list[index].filterType = 'Date';
    } else if (e[1] === 'amount') {
      list[index].filterType = 'Number';
    } else if (e[1] === 'type') {
      list[index].filterType = 'Dropdown';
    } else {
      list[index].filterType = 'String';
    }
    list[index].filterName = e[1];
    list[index].filterNameDisplay = e[0];
    list[index].filterOperator = '';
    list[index].filterValue = '';
    const filterTypeOptions = ACQUIRER_FILTERS_TYPES.filter(({ value: id1 }) => !list.some(({ filterName: id2 }) => id2 === id1));
    setFilterAcquirer(list);
    setFilterTypes(filterTypeOptions);
    setFilterOperators(getFilterOperators(e[1]));
  };

  const handleFromValue = (e, index) => {
    const list = [...filterAcquirer];
    const regex = /^\d*\.?\d*$/;
    if (e.currentTarget && regex.test(e.currentTarget.value.replace(/,/g, ''))) {
      list[index].filterValueFrom = e.currentTarget.value;
      setFilterAcquirer(list);
    } else if (regex.test(e.replace(/,/g, ''))) {
      list[index].filterValueFrom = e;
      setFilterAcquirer(list);
    }
  };

  const handleToValue = (e, index) => {
    const list = [...filterAcquirer];
    const regex = /^\d*\.?\d*$/;
    if (e.currentTarget && regex.test(e.currentTarget.value.replace(/,/g, ''))) {
      list[index].filterValueTo = e.currentTarget.value;
      setFilterAcquirer(list);
    } else if (regex.test(e.replace(/,/g, ''))) {
      list[index].filterValueTo = e;
      setFilterAcquirer(list);
    }
  };

  const handleValue = (e, index) => {
    let selectedValue = '';
    if (filterAcquirer[index].filterName === 'createdAt') {
      if (filterAcquirer[index].filterOperator === 'BT') {
        const date1 = e[0];
        const date2 = e[1];
        const utcDate1 = moment(date1).startOf('day');
        setStartDate(utcDate1);
        const utcDate2 = moment(date2).startOf('day');
        setEndDate(utcDate2);
        const utcString1 = utcDate1.format(MOMENT_FORMAT);
        const utcString2 = utcDate2.format(MOMENT_FORMAT);
        const selectedDate1 = moment.tz(utcString1, selectedAccount.timezone);
        const selectedDate2 = moment.tz(utcString2, selectedAccount.timezone);
        const dateStart = selectedDate1.utc().format(MOMENT_FORMAT);
        const dateEnd = selectedDate2.utc().format(MOMENT_FORMAT);
        selectedValue = `createdAt.GT=${dateStart}&createdAt.LT=${dateEnd}`;
      } else if (filterAcquirer[index].filterOperator === 'LT') {
        const utcDate = moment(e).startOf('day');
        setCurrentDate(utcDate);
        const utcString = utcDate.format(MOMENT_FORMAT);
        const dateSelected = moment.tz(utcString, selectedAccount.timezone);
        const dateStart = dateSelected.utc().format(MOMENT_FORMAT);
        selectedValue = `createdAt.LT=${dateStart}`;
      } else if (filterAcquirer[index].filterOperator === 'GT') {
        const utcDate = moment(e).startOf('day');
        setCurrentDate(utcDate);
        const utcString = utcDate.format(MOMENT_FORMAT);
        const dateSelected = moment.tz(utcString, selectedAccount.timezone);
        const dateStart = dateSelected.utc().format(MOMENT_FORMAT);
        selectedValue = `createdAt.GT=${dateStart}`;
      }
    } else {
      if (!e.currentTarget) {
        selectedValue = e;
      }
      if (e.currentTarget && e.currentTarget.value) {
        selectedValue = e.currentTarget.value;
      }
    }
    const list = [...filterAcquirer];
    list[index].filterValue = selectedValue;
    setFilterAcquirer(list);
  };

  const handleOperator = (e, index) => {
    const list = [...filterAcquirer];
    list[index].filterOperator = e;
    if (list[index].filterValue) {
      if (list[index].filterOperator !== 'BT'
        && list[index].filterName === 'createdAt') {
        handleValue(currentDate, index);
      } else if (list[index].filterOperator === 'BT'
        && list[index].filterName === 'createdAt') {
        const dateList = [startDate, endDate];
        handleValue(dateList, index);
      } else if (list[index].filterOperator !== 'BT'
        && list[index].filterOperator !== 'LT'
        && list[index].filterOperator !== 'GT') {
        const value = filterAcquirer[index].filterValue;
        handleValue(value, index);
      }
    }
    setFilterAcquirer(list);
  };

  const handleAddClick = () => {
    const list = [...filterAcquirer];
    setFilterAcquirer([...list, {
      filterType: '',
      filterName: '',
      filterOperator: '',
      filterValue: '',
      filterNameDisplay: '',
      filterValueFrom: '',
      filterValueTo: '',
      checked: true,
    }]);
  };

  const resetFilters = () => {
    setFilterData({
      pathname,
      search: '',
    });
    setFilterAcquirer([{
      filterType: '',
      filterName: '',
      filterOperator: '',
      filterValue: '',
      filterNameDisplay: '',
      filterValueFrom: '',
      filterValueTo: '',
      checked: true,
    }]);
    setFilterTypes(ACQUIRER_FILTERS_TYPES);
    setStartDate('');
    setEndDate('');
    setCurrentDate('');
    setCount(null);
    history.push(PAGES.ACQUIRER);
  };

  const applyFilters = () => {
    const acquirerFilters = filterAcquirer.filter((item) => item.checked);
    for (let i = 0; i < acquirerFilters.length; i += 1) {
      if (!acquirerFilters[i].filterName || !acquirerFilters[i].filterOperator || !acquirerFilters[i].filterValue) {
        return;
      }
    }
    if (acquirerFilters[0].filterValue || (acquirerFilters[0].filterValueFrom && acquirerFilters[0].filterValueTo)) {
      setCount(acquirerFilters && acquirerFilters.length);
      for (let i = 0; i < acquirerFilters.length; i += 1) {
        if (acquirerFilters[i].checked) {
          if (acquirerFilters[i].filterName === 'createdAt') {
            acquirerFilters[i] = acquirerFilters[i].filterValue;
          } else if (acquirerFilters[i].filterName === 'amount' && acquirerFilters[i].filterOperator === 'BT') {
            const name = acquirerFilters[i].filterName;
            const from = acquirerFilters[i].filterValueFrom.replace(/[. ,:-]+/g, '');
            const to = acquirerFilters[i].filterValueTo.replace(/[. ,:-]+/g, '');
            acquirerFilters[i] = `${name}.GT=${from}&${name}.LT=${to}`;
          } else if (acquirerFilters[i].filterName === 'amount' && acquirerFilters[i].filterOperator !== 'BT') {
            const value = acquirerFilters[i].filterValue.replace(/[. ,:-]+/g, '');
            acquirerFilters[i] = `${acquirerFilters[i].filterName}.${acquirerFilters[i].filterOperator}=${value}`;
          } else {
            acquirerFilters[i] = `${acquirerFilters[i].filterName}.${acquirerFilters[i].filterOperator}=${acquirerFilters[i].filterValue}`;
          }
        }
      }

      const filterParams = encodeURIComponent(acquirerFilters.join('&'));
      const parsed = queryString.parse(location.search);
      const currentPage = 1;
      const sortBy = parsed.sortBy || 'createdAt';
      const direction = parsed.direction || 'DESC';
      const sortParams = `&sortBy=${sortBy}&direction=${direction}`;
      if (location.search && parsed.sortBy && parsed.pageNum && parsed.direction) {
        setFilterData({
          pathname,
          search: `?filterParams=${filterParams}&pageNum=${currentPage}${sortParams}`,
          filterAcquirer,
        });
        history.push({
          pathname: PAGES.ACQUIRER,
          search: `?filterParams=${filterParams}&pageNum=${currentPage}${sortParams}`,
        });
      } else {
        setFilterData({
          pathname,
          search: `?filterParams=${filterParams}`,
          filterAcquirer,
        });
        history.push({
          pathname: PAGES.ACQUIRER,
          search: `?filterParams=${filterParams}`,
        });
      }
      setOpen(false);
    }
  };

  const columns = [
    {
      title: 'NAME',
      dataIndex: 'name',
      width: '20%',
      align: 'left',
      sorter: true,
      sortDirections: ['ascend', 'descend', 'ascend'],
      render: (name) => (
        <span>
          {name || <>&#8211;</>}
        </span>
      ),
    },
    {
      title: 'TYPE',
      dataIndex: 'type',
      width: '20%',
      align: 'left',
      sorter: true,
      sortDirections: ['ascend', 'descend', 'ascend'],
      render: (type) => (
        <span>
          {type || <>&#8211;</>}
        </span>
      ),
    },
    {
      title: 'IS TEST',
      dataIndex: 'test',
      width: '20%',
      align: 'left',
      sorter: false,
      sortDirections: ['ascend', 'descend', 'ascend'],
      render: (istest) => (
        <span>
          {istest === true ? 'Yes' : 'No'}
        </span>
      ),
    },
    {
      title: 'CREATED ON',
      dataIndex: 'createdAt',
      width: '20%',
      align: 'left',
      sorter: true,
      sortDirections: ['ascend', 'descend', 'ascend'],
      defaultSortOrder: 'descend',
      render: (createdAt) => {
        if (createdAt && selectedAccount && selectedAccount.timezone) {
          const tzDate = moment
            .utc(createdAt)
            .tz(selectedAccount.timezone)
            .format('MMM DD, YYYY, hh:mm a');
          return (<span>{tzDate}</span>);
        }
        return (
          <>&#8211;</>
        );
      },
    },
    {
      title: 'ACTION',
      dataIndex: 'action',
      width: '20%',
      align: 'center',
      render: (text, record) => (
        <span>
          <Tooltip placement="top" title="Edit">
            <Icon
              type="edit"
              style={{ fontSize: '20px', cursor: 'pointer' }}
              onClick={(e) => { e.stopPropagation(); showEditAcquirerModal(record); }}
            />
          </Tooltip>
          <Tooltip placement="top" title="Delete">
            <Icon
              type="delete"
              className="ml-3"
              style={{ fontSize: '20px', marginRight: '8px', cursor: 'pointer' }}
              onClick={(e) => { e.stopPropagation(); showDeleteAcquirerModal(record); }}
            />
          </Tooltip>
        </span>
      ),
    },
  ];

  if (loading || !selectedAccount) {
    return <Loading />;
  }

  return (
    <Card>
      <Row className="my-2">
        <div className="d-flex justify-content-end">
          <Col>
            <SpButton
              type="secondary"
              shape="round"
              ghost
              className="mr-3"
              onClick={() => setAddAcquirerModal(true)}
            >
              {'\u002B'}&nbsp;Add Acquirer
            </SpButton>
            <span>
              {
                exportData !== null
                  ? (
                    <Tooltip placement="left" title="Click here to export Acquirer">
                      <CSVLink
                        target="_blank"
                        className="mr-3"
                        filename="Acquirer Report.csv"
                        data={exportData}
                        headers={exportHeaders}
                        onMouseEnter={() => setFillColor(true)}
                        onMouseLeave={() => setFillColor(false)}
                      >
                        <ExportIcon
                          fill={fillColor
                            ? '#279dfe'
                            : '#C0C0C0'}
                        />
                      </CSVLink>
                    </Tooltip>
                  ) : null
              }
            </span>
            <span ref={myRef}>
              <span
                onClick={() => setOpen(!open)}
                style={{ cursor: 'pointer' }}
                onMouseEnter={() => setFilterColor(true)}
                onMouseLeave={() => setFilterColor(false)}
              >
                {open && (
                  <Badge count={count} style={{ backgroundColor: '#0090ff' }}>
                    <FilterIcon
                      fill={filterColor
                        ? '#279dfe'
                        : '#C0C0C0'}
                    />
                  </Badge>
                )}
                {!open && (
                  <Tooltip placement="left" title="Click here to filter Acquirer">
                    <Badge count={count} style={{ backgroundColor: '#0090ff' }}>
                      <FilterIcon
                        fill={filterColor
                          ? '#279dfe'
                          : '#C0C0C0'}
                      />
                    </Badge>
                  </Tooltip>
                )}
              </span>
              {open && (
                <FilterWrapper
                  style={{ marginLeft: '-120px' }}
                >
                  <Filters
                    filtersGrid={filterAcquirer}
                    filterTypes={filterTypes}
                    handleChange={handleChange}
                    onCheck={onCheck}
                    fiterOperators={fiterOperators}
                    handleOperator={handleOperator}
                    handleValue={handleValue}
                    startDate={startDate}
                    endDate={endDate}
                    currentDate={currentDate}
                    handleFromValue={handleFromValue}
                    handleToValue={handleToValue}
                    stuses={AcquirerTypes}
                    placeholder={placeholder}
                  />
                  <div className="px-4 mt-2">
                    {
                      filterAcquirer.length < ACQUIRER_FILTERS_TYPES.length && (
                        <div className="mb-2 ml-3" style={{ cursor: 'pointer' }}>
                          <SpText
                            fontWeight="600"
                            color="#279dfe"
                            onClick={handleAddClick}
                          >
                            +&nbsp; Add another filter
                          </SpText>
                        </div>
                      )
                    }
                  </div>
                  <div className="d-flex mb-2 justify-content-end mr-3">
                    <SpButton
                      type="secondary"
                      shape="round"
                      className="mr-2"
                      ghost
                      onClick={resetFilters}
                    >
                      Clear
                    </SpButton>
                    <SpButton
                      type="primary"
                      shape="round"
                      onClick={applyFilters}
                    >
                      Save
                    </SpButton>
                  </div>
                </FilterWrapper>
              )}
            </span>
          </Col>
        </div>
      </Row>
      {/* DELETE ACQUIRER MODAL */}
      {deleteAcquirerModal && (
        <DeleteAcquirer
          visible={deleteAcquirerModal}
          selectedAcquirer={selectedAcquirer}
          submitting={submitting}
          close={() => setDeleteAcquirerModal(false)}
          submit={deleteSelectedAcquirer}
        />
      )}

      {/* ADD ACQUIRER MODAL */}
      {addAcquirerModal && (
        <AddAcquirer
          visible={addAcquirerModal}
          submitting={submitting}
          selectedAccount={selectedAccount}
          close={() => setAddAcquirerModal(false)}
          submit={addNewAcquirer}
        />
      )}

      {/* Edit ACQUIRER MODAL */}
      {editAcquirerModal && (
        <UpdateAcquirer
          visible={editAcquirerModal}
          submitting={submitting}
          selectedAcquirer={selectedAcquirer}
          close={() => setEditAcquirerModal(false)}
          submit={editAcquirer}
        />
      )}

      <Table
        rowClassName={() => 'ant-table-clickable-row'}
        columns={columns}
        rowKey={(record) => record.gid}
        dataSource={acquirer}
        pagination={pagination}
        onChange={handleTableChange}
      />
    </Card>
  );
};

const mapStateToProps = (state) => ({
  acquirer: state.acquirer.content,
  loading: state.loading.loading,
  test: state.account.test,
  totalElements: state.acquirer.totalElements,
  selectedAccount: state.account.selectedAccount,
  submitting: state.loading.submitting,
  validator: state.loading.validator,
  preserveFilters: state.filterParams.preserveFilters,
  isMobileView: state.mobileView.isMobileView,
});

const mapDispatchToProps = (dispatch) => ({
  fetchAcquirer: param => dispatch(acquirerActions.fetchAcquirer({
    payload: param,
  })),
  addAcquirer: param => dispatch(acquirerActions.addAcquirer({
    payload: param,
  })),
  deleteAcquirer: param => dispatch(acquirerActions.deleteAcquirer({
    payload: param,
  })),
  updateAcquirer: param => dispatch(acquirerActions.updateAcquirer({
    payload: param,
  })),
  setFilterData: (value) => dispatch(filterParamsActions.setFilterData({
    type: FILTERS_SPECS.SET_FILTER_DATA,
    payload: value,
  })),
});

// $FlowFixMe
export default connect(mapStateToProps, mapDispatchToProps)(Acquirer);
